<template>
  <div>
    <Pane />

    <div class="container">
      <a-form
        :form="form"
        :label-col="{ span: 8 }"
        :wrapper-col="{ span: 12 }"
        :colon="false"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="品类名称">
              <a-select
                v-decorator="[
                  'categoryCode',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in typeList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="子品类名称">
              <a-input
                v-decorator="[
                  'subCategoryName',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="子品类编码">
              <a-input
                v-decorator="[
                  'subCategoryCode',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废方式">
              <a-select
                v-decorator="[
                  'scrapMethod',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in ['平均年限法']"
                  :key="item"
                  :value="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="报废时限(月)">
              <a-input-number
                style="width: 100%"
                :min="1"
                v-decorator="[
                  'scrapLimitMonths',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="净残值率">
              <a-input-number
                style="width: 100%"
                :min="0"
                :max="1"
                v-decorator="[
                  'netSalvageRate',
                  { rules: [{ required: true, message: '请输入！' }] },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item label="状态">
              <a-select
                v-decorator="[
                  'status',
                  { rules: [{ required: true, message: '请选择！' }] },
                ]"
              >
                <a-select-option
                  v-for="item in statusList"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        
        <div class="center">
          <a-space>
            <a-button type="primary" html-type="submit" :loading="loading"
              >保存</a-button
            >
            <a-button @click="$close($route.path)">关闭</a-button>
          </a-space>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import request from "@/api/request";
import { mapGetters } from "vuex";

function edit(data) {
  return request({
    url: "/office-service/fixed-asset-category/update",
    data,
    method: 'post'
  });
}
export default {
  name: "editFixedAssetsCategory",

  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      id: null
    };
  },

  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    typeList() {
      return this.findDataDict("fixed_asset_type");
    },
    statusList() {
      return this.findDataDict("fixed_asset_status_A");
    }
  },
  mounted() {
    const { id } = this.$route.query;
    this.id = id;
    if (id) {
      this.loading = true;
      request({
        url: `/office-service/fixed-asset-category/query/${id}`,
        method: "get",
      })
       .then((res) => {
          this.form.setFieldsValue(res);
        })
       .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true;

          edit({
            ...values,
            id: this.id,
          })
            .then(() => {
              this.form.resetFields();
              this.$close(this.$route.path);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background-color: #fff;
  padding: 24px 160px;
}

.center {
  margin-top: 80px;
}
</style>